export default __webpack_public_path__ + "static/media/icon_pdf.042c103c.svg";